module.exports = {
  SET_DIRECTIONS: 'SET_DIRECTIONS',
  SET_DIRECTION_FLAG: 'SET_DIRECTION_FLAG',
  SWITCH_DEPARTURE_ARRIVAL: 'SWITCH_DEPARTURE_ARRIVAL',
};
